/**
 * @generated SignedSource<<f78cd99105ad931208c0935c08c85e6b>>
 * @relayHash f01c3842d520b2597fb358aa5b23f978
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9036724822e9ddfeb73bbf223316d7f99dea6ca0f6a27a41422ef3d94c598be8

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StakeholdersPageQuery$variables = {
  cloudId: string;
};
export type StakeholdersPageQuery$data = {
  readonly stakeholderComms_getStakeholdersByAssignmentV2: {
    readonly " $fragmentSpreads": FragmentRefs<"StakeholderPageContent">;
  };
};
export type StakeholdersPageQuery = {
  response: StakeholdersPageQuery$data;
  variables: StakeholdersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "assignmentId",
            "value": null
          },
          {
            "kind": "Literal",
            "name": "assignmentType",
            "value": "ORG"
          },
          {
            "kind": "Variable",
            "name": "externalAssignmentId",
            "variableName": "cloudId"
          }
        ],
        "kind": "ObjectValue",
        "name": "assignmentIdInput"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      }
    ],
    "kind": "ObjectValue",
    "name": "stakeholderConnectionInput"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "StakeholderCommsStakeholderConnection",
          "kind": "LinkedField",
          "name": "stakeholderComms_getStakeholdersByAssignmentV2",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "StakeholderPageContent"
            }
          ]
        },
        "action": "THROW",
        "path": "stakeholderComms_getStakeholdersByAssignmentV2"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsStakeholderConnection",
        "kind": "LinkedField",
        "name": "stakeholderComms_getStakeholdersByAssignmentV2",
        "plural": false,
        "selections": [
          {
            "concreteType": "StakeholderCommsStakeholder",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9036724822e9ddfeb73bbf223316d7f99dea6ca0f6a27a41422ef3d94c598be8",
    "metadata": {},
    "name": "StakeholdersPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1b2309b77070879ffc085d4d045f4428";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
